import * as angular from "angular";
import * as _ from "lodash";

angular
  .module('bringoz.admin.commons')
  .filter('bringozTimeAgo', bringozTimeAgo);

function bringozTimeAgo($filter, moment, $translate) {
  return function bringozTimeAgoFilter(timeToCheck, defaultValue) {

    if (!timeToCheck) {
      return defaultValue || '---';
    }

    const today = moment(),
      fromDate = moment(timeToCheck);

    const months = today.diff(fromDate, 'months'),
      days = today.diff(fromDate, 'days'),
      hours = today.diff(fromDate, 'hours'),
      minutes = today.diff(fromDate, 'minutes'),
      seconds = today.diff(fromDate, 'seconds'),
      timeCollection = [
        {key: 'Month', pluralKey: 'Months', difference: months},
        {key: 'Day', pluralKey: 'Days', difference: days},
        {key: 'Hour', pluralKey: 'Hours', difference: hours},
        {key: 'Minute', pluralKey: 'Minutes', difference: minutes},
        {key: 'Second', pluralKey: 'Seconds', difference: seconds}
      ];

    const timeAgoFound = _.find(timeCollection, function (time) {
      return time.difference !== 0;
    });

    if (!timeAgoFound) {
      return defaultValue || '---';
    }

    if (timeAgoFound.difference > 0) {
      return $translate.instant('X_TIME_AGO', {
        value: timeAgoFound.difference,
        unit: timeAgoFound.difference > 1 ?
          $translate.instant(timeAgoFound.pluralKey) :
          $translate.instant(timeAgoFound.key)
      });
    } else if (timeAgoFound.difference < 0) {
      timeAgoFound.difference *= -1;
      return $translate.instant('IN_X_TIME', {
        value: timeAgoFound.difference,
        unit: timeAgoFound.difference < -1 ?
          $translate.instant(timeAgoFound.pluralKey) :
          $translate.instant(timeAgoFound.key)
      });
    }
  }
}
